module.exports = __webpack_public_path__ + "static/media/vault.889067ad.svg";